import axios from 'axios';

const API = axios.create({
    //baseURL: "http://localhost:8000/clean",
    baseURL:  "https://cigli-hastane-rest.azurewebsites.net/clean"

});

export default API;
